import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-completed',
  templateUrl: './fh-svg-completed.component.html',
  styleUrl: './fh-svg-completed.component.scss'
})
export class FhSvgCompletedComponent {
  @Input() color: string = '';
}
